import React from 'react';
import { FilterBarSection, FilterDropdownField } from './FilterControls';

type FilterValue = {
  grade: string;
  division: string;
  status: string;
  siblings: string;
};

type StudentsFamiliesFiltersProps = {
  value: FilterValue;
  onChange: (value: FilterValue) => void;
  mobile?: boolean;
  className?: string;
};

type SelectOption = {
  value: string;
  label: string;
};

const GRADES: SelectOption[] = [
  { value: 'All Grades', label: 'All' },
  { value: 'Nursery', label: 'Nursery' },
  { value: 'Pre-K', label: 'Pre-K' },
  { value: 'Kindergarten', label: 'Kindergarten' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
];

const DIVISIONS: SelectOption[] = [
  { value: 'All Divisions', label: 'All' },
  { value: 'Boys', label: 'Boys' },
  { value: 'Girls', label: 'Girls' },
  { value: 'Pre-School', label: 'Pre-School' },
];

const STATUSES: SelectOption[] = [
  { value: 'All Statuses', label: 'All' },
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
  { value: 'Withdrawn', label: 'Withdrawn' },
  { value: 'Graduated', label: 'Graduated' },
  { value: 'Transferred', label: 'Transferred' },
  { value: 'Archived', label: 'Archived' },
];

const SIBLINGS: SelectOption[] = [
  { value: 'Show All', label: 'All' },
  { value: 'Has Siblings', label: 'Has Siblings' },
  { value: 'No Siblings', label: 'No Siblings' },
];

export const StudentsFamiliesFilters = ({
  value,
  onChange,
  mobile = false,
  className = '',
}: StudentsFamiliesFiltersProps) => (
  <FilterBarSection
    mobile={mobile}
    className={className}
    testId="students-families-filter-bar"
  >
    <FilterDropdownField
      label="Grade"
      value={value.grade}
      options={GRADES}
      onChange={(next) => onChange({ ...value, grade: next })}
      mobile={mobile}
      className={mobile ? 'w-full rounded-xl border border-gray-100 bg-white' : 'border-r border-gray-100 pr-1'}
      testId="students-families-filter-grade-button"
    />
    <FilterDropdownField
      label="Division"
      value={value.division}
      options={DIVISIONS}
      onChange={(next) => onChange({ ...value, division: next })}
      mobile={mobile}
      className={mobile ? 'w-full rounded-xl border border-gray-100 bg-white' : 'border-r border-gray-100 pr-1'}
      testId="students-families-filter-division-button"
    />
    <FilterDropdownField
      label="Status"
      value={value.status}
      options={STATUSES}
      onChange={(next) => onChange({ ...value, status: next })}
      mobile={mobile}
      className={mobile ? 'w-full rounded-xl border border-gray-100 bg-white' : 'border-r border-gray-100 pr-1'}
      testId="students-families-filter-status-button"
    />
    <FilterDropdownField
      label="Siblings"
      value={value.siblings}
      options={SIBLINGS}
      onChange={(next) => onChange({ ...value, siblings: next })}
      mobile={mobile}
      className={mobile ? 'w-full rounded-xl border border-gray-100 bg-white' : 'pr-1'}
      testId="students-families-filter-siblings-button"
    />
  </FilterBarSection>
);

export type { FilterValue };
